// extracted by mini-css-extract-plugin
export default {"rulesSlide":"OfflineInfoSlide_rulesSlide__CUaKe","contentSlide":"OfflineInfoSlide_contentSlide__8mI9E"};